import { useContext, useState } from "react";
import { Box, Grid, Stack, Toolbar, Typography } from "@mui/material";
import AiChatHelp from '../../../right-panel/help/aiChat'
import CustomToolTip from "../../toolTip";
import ProfileContextMenu from "../../../profile/navigation/profileContextMenu";
import custom from '../../../../styles/mui/szVariables.json'
import { 
    DataContext, 
    DataDispatchContext 
} from '../../../../contexts/data/dataContext'
import { analyticsCta, analyticsDomain } from '../../../../services/constants'
import { sendClickAnalytics } from '../../../common/util/util'

type Props = {
    menuItems: Function 
    itemList: any[]
    selected: string
}

export default function TopNavigation({ 
        menuItems, 
        itemList,
        selected
    }: Props) {
    const pathName = window.location.hash.substring(2) || 'dashboard';    
    const data = useContext(DataContext)
    const dispatch: any = useContext(DataDispatchContext)  
    const [showProfileMenu, setShowProfileMenu] = useState(null)

    function handleProfileMenu(event: any) {
        setShowProfileMenu(showProfileMenu ? null : event.currentTarget);
        const path = pathName==="reports"?'trends':pathName
        sendClickAnalytics(`/${pathName}`, {
              domain: analyticsDomain[path] || 'dashboard',
              name: analyticsCta.profile,
              metadata: {},
          })
    }

    function handleHelp() {
        if(data?.rightPanel?.key==='help') {
            dispatch({
                type: 'setRightPanel',
                rightPanel: null
            })
        } else {
            dispatch({
                type: 'setRightPanel',
                rightPanel: <AiChatHelp key="help"/>
            })
        }
      
    }
        
    return (
        <Grid container direction="row" 
                justifyContent="flex-start"
                height={custom.sizes.hf}
                sx={ {
                    display: {
                        xs:'none', 
                        sm:'none',
                        md:'flex', 
                        lg:'flex'
                    },
                    maxWidth: '100%'
                }}>
            <Grid item xs={0} sm={0} md={8} lg={8} 
                    justifyContent="flex-start" >
                <Toolbar sx={{ height: custom.sizes.hf }}>
                    {menuItems([...itemList])}
                </Toolbar>
            </Grid>
            <Grid item xs={0} sm={0} md={4} lg={4} 
                    justifyContent="flex-end" >
                <Box height={custom.sizes.hf}
                    display="flex" 
                    flexDirection={"column"}
                    justifyContent={"center"}
                    sx = {{ cursor: 'pointer' }} 
                    >
                    <Stack direction={"row"}
                        justifyContent={"flex-end"} 
                        alignContent={"center"}
                        spacing={custom.spacing.xxs}
                        pt={custom.spacing.xxs}
                        >
                        <Box height={custom.sizes.hf}
                                display={"flex"}
                                flexDirection={"column"}
                                justifyContent={"center"}>
                            <Typography 
                                textAlign={"center"}
                                variant="szHeading.Regular.xxSmall" 
                                id="helloName"
                                onClick={handleProfileMenu}>
                                Hello {data?.customer?.firstName}
                            </Typography>
                        </Box>
                        <CustomToolTip message="Profile" placement="bottom" >   
                            <Box component="img"
                                id="profileIcon" 
                                height={custom.sizes.lg} 
                                width={custom.sizes.lg}
                                pt="20px" 
                                onClick={handleProfileMenu} 
                                src = {`/images/UserCircle${selected==='profile'?'Selected':''}.svg`}
                                sx={{ cursor: 'pointer'}} />   
                        </CustomToolTip>
                        <CustomToolTip message="Get help" placement="bottom" >                           
                            <Box component="img"
                                height={custom.sizes.lg} 
                                width={custom.sizes.lg}
                                pt="20px" 
                                src = {`/images/Question${data?.rightPanel?.key==='help'?'Selected':''}.svg`}
                                onClick={handleHelp} id="help"
                                sx={{ 
                                    ml: custom.spacing.xxs, 
                                    cursor: 'pointer'
                                }} />
                        </CustomToolTip>  
                    </Stack>  
                </Box>
                <ProfileContextMenu 
                        anchorEl={showProfileMenu} 
                        setPopperState={setShowProfileMenu}/>
            </Grid>
        </Grid>
    )
}